<template>
  <div class="dashboard">
    <SideBar 
      :groups="results" 
      :isSidebarOpen="isSidebarOpen"
      @toggle-sidebar="toggleSidebar"
      @close-sidebar="closeSidebar"
      @handle-logout="handleLogout"
    />
    <div class="main-content">
      <TopBar 
        :source="tag"
        @toggle-sidebar="toggleSidebar"
        @selected="getSelected"
      />
      <div class="content-area">        <!-- News Section -->
        <SectionContainer :enableHoverEffect="true">
          <SectionHeader 
            title="Latest News" 
            viewAllLink="/news" 
            viewAllText="View All News"
          />
          <div class="news-grid">
            <NewsCard 
              v-for="item in news.slice(0, 3)" 
              :key="item.NewsID" 
              :newsItem="item"
            />
          </div>
        </SectionContainer>
        
        <!-- Group Section -->
        <SectionContainer :enableHoverEffect="true">
          <SectionHeader title="Article Groups" />
          <div class="group-grid">
            <GroupCard 
              v-for="item in results" 
              :key="item.GroupID" 
              :group="item"
            />
          </div>
        </SectionContainer>
      </div>
      
      <AppFooter />

    </div>
  </div>
</template>

<script>
import axios from "axios";
import router from "../router";
import SideBar from "./SideBar.vue";
import TopBar from "./TopBar.vue";
import AppFooter from "./AppFooter.vue";
import NewsCard from "./NewsCard.vue";
import GroupCard from "./GroupCard.vue";
import SectionHeader from "./SectionHeader.vue";
import SectionContainer from "./SectionContainer.vue";
import config from "../config.js";
import "../assets/css/dashboard.css";

export default {
  name: "dashboard",  components: {
    SideBar,
    TopBar,
    AppFooter,
    NewsCard,
    GroupCard,
    SectionHeader,
    SectionContainer
  },
  data() {
    return {
      results: [],
      news: [],
      user: [],
      LinkTitle: null,
      LinkDescription: null,
      textchat: null,
      messages: [],
      timer: "",
      usercookie: $cookies.get("arch-it-portal"),
      group: "",
      tag: [],
      isLoading: false,
      showArticleMenu: false,
      isSidebarOpen: false,
    };
  },
  methods: {
    mouseOver: function (text, description) {
      this.LinkTitle = text;
      this.LinkDescription = description;
    },    hoverOut: function () {
      this.LinkTitle = null;
      this.LinkDescription = null;
    },
    toggleArticleMenu: function () {
      this.showArticleMenu = !this.showArticleMenu;
    },
    toggleSidebar: function () {
      this.isSidebarOpen = !this.isSidebarOpen;
      // Prevent scrolling on body when sidebar is open on mobile
      document.body.style.overflow = this.isSidebarOpen ? "hidden" : "";
    },
    closeSidebar: function () {
      this.isSidebarOpen = false;
      document.body.style.overflow = "";
    },
    handleResize: function () {
      if (window.innerWidth > 768 && this.isSidebarOpen) {
        this.closeSidebar();
      }
    },
    getToken() {
      // Get token from cookie
      return this.$cookies.get("arch-it-portal") || this.usercookie;
    },    getgroup: function () {
      const token = this.getToken();
      axios
        .get(
          config.getApiUrl("group"),
          token
            ? {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              }
            : {}
        )
        .then((response) => (this.results = response.data));
    },    getNews: function () {
      const token = this.getToken();
      axios
        .get(
          config.getApiUrl("news/3"),
          token
            ? {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              }
            : {}
        )
        .then((response) => (this.news = response.data));
    },
    getuser: function () {
      var notif;
      let params = new URLSearchParams();
      params.append("user", this.usercookie);      const token = this.getToken();
      axios({
        method: "post",
        url: config.getApiUrl("get-user"),
        data: params,
        ...(token ? { headers: { Authorization: `Bearer ${token}` } } : {}),
      }).then((response) => {
        this.user = response.data;
        this.loginstatus(response.data);
      });
    },    sendmessage: function (messageData) {
      this.isLoading = true;
      let params = new URLSearchParams();
      params.append("textchat", messageData.textchat);
      params.append("userID", messageData.userId || this.user.userID);      const token = this.getToken();
      axios({
        method: "post",
        url: config.getApiUrl("send-message"),
        data: params,
        ...(token ? { headers: { Authorization: `Bearer ${token}` } } : {}),
      })
        .then((response) => {
          //console.log(response);
        })
        .catch(function (error) {
          //console.log(error);
        });
      this.fetchMessages();
    },    fetchMessages: function () {
      const token = this.getToken();
      axios
        .get(
          config.getApiUrl("get-message"),
          token
            ? {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              }
            : {}
        )
        .then((response) => (this.messages = response.data));
    },
    ClickPopUp: function (e) {
      $("#" + e).modal("");
    },
    loginstatus: function (userData) {
      console.log(userData);
      // If expire is missing or in the past, redirect to login
      if (
        !userData ||
        !userData.expire ||
        Number(userData.expire) < Math.floor(Date.now() / 1000)
      ) {
        router.push({
          name: "Login",
        });
      }
    },
    handleLogout: function () {
      $cookies.remove("arch-it-portal");
      router.push({
        name: "Login",
      });
    },    getTag: function () {
      const token = this.getToken();
      axios
        .get(
          config.getApiUrl("get-tag"),
          token
            ? {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              }
            : {}
        )
        .then((response) => (this.tag = response.data));
    },
    getSelected(result) {
      //console.log(result)
      window.open(result.value, "_blank");
    },
    formattedDisplay(result) {
      return result.text;
    },
  },
  beforeCreate() {
    // Only redirect if the cookie is truly missing or empty (do not check JWT format here)
    let checkcookie = null;
    // Try both this.$cookies and window.$cookies for maximum compatibility
    if (this.$cookies && typeof this.$cookies.get === "function") {
      checkcookie = this.$cookies.get("arch-it-portal");
    } else if (
      typeof window !== "undefined" &&
      window.$cookies &&
      typeof window.$cookies.get === "function"
    ) {
      checkcookie = window.$cookies.get("arch-it-portal");
    } else if (
      typeof $cookies !== "undefined" &&
      typeof $cookies.get === "function"
    ) {
      checkcookie = $cookies.get("arch-it-portal");
    } else {
      // fallback: try to read cookie manually
      const match = document.cookie.match(/(?:^|; )arch-it-portal=([^;]*)/);
      checkcookie = match ? decodeURIComponent(match[1]) : null;
    }
    // if (!checkcookie || checkcookie === 'undefined' || checkcookie === undefined || checkcookie === null || checkcookie === '') {
    //   router.push({
    //     name: 'Login'
    //   })
    // }
  },
  created() {
    this.getuser();
    this.getgroup();
    this.getTag();
    this.getNews();
    this.fetchMessages();
    this.timer = setInterval(this.fetchMessages, 60000);
  },
  mounted: function () {
    $(".modal").modal();
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    clearInterval(this.timer);
    window.removeEventListener("resize", this.handleResize);
  },
};
</script>

<style scoped>
/* Minimal local styles */
</style>



// WEBPACK FOOTER //
// src/components/Dashboard.vue